import Image from 'next/image';

import starsImg from '../../assets/images/star-symbol.svg';

const STAR_COUNT = 5;

export interface StarRatingProps {
  totalStars?: number;
  activeStars: number;
  readonly?: boolean;
  onChange?: (starNumber: number) => void;
}

export default function StarRating(props: StarRatingProps) {
  const { totalStars, activeStars, onChange, readonly } = props;
  const array = Array.from(Array(totalStars || STAR_COUNT).keys()).map(value => value + 1);
  return (
    <div
      className="flex items-center animate-in fade-in sm:justify-center md:justify-start"
      title={`Rated ${activeStars} Star(s)`}
    >
      {array.map(value => (
        <div
          tabIndex={readonly ? -1 : 1}
          className={readonly ? 'pointer-events-none cursor-default select-none' : ''}
          key={value}
          onClick={event => {
            if (readonly) return;
            onChange && onChange(value);
          }}
        >
          {/* <svg
            aria-hidden="true"
            className={`h-6 w-6 ${value <= activeStars ? 'text-yellow-400' : 'text-gray-300 dark:text-gray-500'}`}
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <title>Star</title>
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
          </svg> */}
          <Image src={starsImg} alt="Pet Three" className="h-5 w-5" />
        </div>
      ))}
    </div>
  );
}
